import { sineOut } from "svelte/easing";

export const fade = (_, { delay = 0, duration = 150, absolute = false }) => ({
  duration,
  delay,
  easing: sineOut,
  css: (t) => {
    return `opacity: ${t}; ${absolute ? "position: absolute;" : ""}`;
  },
});

export const grow = (_) => ({
  duration: 800,
  easing: sineOut,
  css: (t) =>
    `transform-origin: 0 0; transform: scaleX(${1 - t}); opacity: ${t * 10};`,
});

export const slideOut = (_, { left = false, duration = 250, delay = 0 }) => ({
  duration,
  easing: sineOut,
  delay,
  css: t => {
    return `transform: translateX(${left ? -100 + t * 100 : 100 - t * 100}%); position: absolute; opacity: ${t};`;
  }
});

export const slideIn = (_, { left = false, duration = 250, delay = 250 }) => ({
  duration,
  easing: sineOut,
  delay,
  css: t => {
    return `transform: translateX(${left ? 100 - t * 100 : -100 + t * 100}%); opacity: ${t};`
  }
})
